import { render, staticRenderFns } from "./SetPriority.vue?vue&type=template&id=60c9a70b&"
import script from "./SetPriority.vue?vue&type=script&lang=js&"
export * from "./SetPriority.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports